/**
 * Loads the YouTube IFrame API once and resolves when YT.Player is available.
 * Safe for concurrent calls and coexists with other onYouTubeIframeAPIReady hooks.
 */
export function loadYouTubeIframeAPI() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('No window'));
  }
  if (window.YT && window.YT.Player) {
    return Promise.resolve();
  }

  if (!window.__flYtApiPromise) {
    window.__flYtApiPromise = new Promise((resolve) => {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        resolve();
      };

      const previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        try {
          if (typeof previous === 'function') previous();
        } catch {
          /* ignore */
        }
        finish();
      };

      if (!document.querySelector('script[data-fl-youtube-iframe-api]')) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.async = true;
        tag.dataset.flYoutubeIframeApi = '1';
        document.body.appendChild(tag);
      }

      // If the script was already cached and YT appeared before our callback assignment
      queueMicrotask(() => {
        if (window.YT && window.YT.Player) finish();
      });
    });
  }

  return window.__flYtApiPromise;
}
